"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

var classnames_1 = __importDefault(require("classnames"));

require("./styles.css");
/** Converts `'{{wbr}}'` tokens found in the `children` to a `<wbr>` (Line Break Opportunity) element.
 *
 * Used with Chinese/Japanese/Korean (CJK) text to define when line breaks should occur.
 * If a `'{{wbr}}'` token is detected in the `children`, the `.rwc-wbr` class is applied to the element, which sets `word-break: keep-all` for CJK languages.
 * @see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/wbr
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/word-break
 *
 * @param {string | ReactElement<{ field: { editable?: boolean; value?: any } }>} [children]
 * should either be a `string` or a Sitecore JSS `<Text>` Element.
 * `<Text>` contains an `editable` boolean to detect if the page is in EditMode.
 * If `true`, the element is rendered as-is so content authors can edit text inline with Sitecore Experience Editor.
 * @see https://github.com/Sitecore/jss/blob/dev/packages/sitecore-jss-react/src/components/Text.tsx
 *
 * @param {keyof JSX.IntrinsicElements} [tag] the HTMLElement to be rendered. Default = 'div'.
 *
 * @example
 * <WBRString tag="span">Hello {{wbr}} World</WBRString>
 *
 * @example
 * <WBRString tag="p"><Text field={MySitecoreField} /></WBRString>
 */


var WBRString = function (_a) {
  var _b, _c, _d, _e, _f;

  var _g = _a.tag,
      Tag = _g === void 0 ? 'div' : _g,
      className = _a.className,
      children = _a.children,
      htmlAttributes = __rest(_a, ["tag", "className", "children"]);
  /** Don't do any token replacement. Just render as-is. */


  var unmodified = function () {
    return (0, jsx_runtime_1.jsx)(Tag, __assign({
      className: (0, classnames_1.default)(className)
    }, htmlAttributes, {
      children: children
    }));
  };
  /** Replace the {{wbr}} tokens and add the .rwc-wbr class. */


  var modified = function (value) {
    return (0, jsx_runtime_1.jsx)(Tag, __assign({
      className: (0, classnames_1.default)(className, {
        'rwc-wbr': value.includes('{{wbr}}')
      })
    }, htmlAttributes, {
      dangerouslySetInnerHTML: {
        __html: value.replace(/{{wbr}}/g, '<wbr>')
      }
    }));
  };

  try {
    if (children === undefined) {
      return null;
    }

    if (typeof children === 'string') {
      return modified(children);
    } // If `children` is HTML, return as-is.


    if (((_b = children === null || children === void 0 ? void 0 : children.props) === null || _b === void 0 ? void 0 : _b.field) === undefined) {
      return unmodified();
    }

    return ((_d = (_c = children === null || children === void 0 ? void 0 : children.props) === null || _c === void 0 ? void 0 : _c.field) === null || _d === void 0 ? void 0 : _d.editable) ? unmodified() : modified((_f = (_e = children === null || children === void 0 ? void 0 : children.props) === null || _e === void 0 ? void 0 : _e.field) === null || _f === void 0 ? void 0 : _f.value);
  } catch (exception) {
    return null;
  }
};

exports.default = WBRString;